import TrackerException from '../exceptions/trackerexception';
import { logDebugging, logError } from '../log/logger';
import addTrackerToDOM from './print/addTrackerToDOM';
import AdParams from './params/adparams';
import CommonParams from './params/commonparams';
import changeOrderAttributes from './validations/changeOrderAttributes';
import convertParamsToString from './validations/convertParamsToString';
import removeEmptyAttrFromObj from './validations/removeEmptyAttrFromObj';
import { ENDPOINTS, EVENT_STATUS, STATUS_FRQ, TYPECONTENT } from './constants/TrackingConstants';
import { counterAd } from './constants/counterad.player';
import getDeliveryWinner from './validations/deliveries';
import { checkImpression } from './validations/impressions';
import * as TAPPX_GLOBAL_PARAMS from './constants/tappxglobalparams';
import ContentParams from './params/contentparams';
import ContentCommonParams from './params/contentcommonparams';

export default class Trackings {
  constructor(typeContent, customerId) {
    if (!typeContent) {
      throw new TrackerException(101, 'TypeContent is not defined');
    }
    if (!customerId) {
      throw new TrackerException(102, 'CustomerId is not defined');
    }
    this.typeContent = typeContent;
    this.customerId = customerId;
    this.eventReached = [];
    this.msg = '';
    this.hash = '';
  }

  setComonParams(commonParams) {
    if (commonParams instanceof CommonParams) {
      this.commonParams = commonParams;
      this.commonParams.setCustomerId(this.customerId);
    } else {
      throw new TrackerException(103, 'CommonParams is not a valid object');
    }
  }

  getComonParams() {
    return this.commonParams;
  }

  setAdParams(adParams) {
    if (adParams instanceof AdParams) {
      this.adParams = adParams;
    } else {
      throw new TrackerException(107, 'adParams is not a valid object');
    }
  }

  setContentParams(contentParams) {
    if (contentParams instanceof ContentParams) {
      contentParams.setPlayerLoadTimeStamp(TAPPX_GLOBAL_PARAMS.DATES.SERVICE_TIMESTAMP);
      this.adParams = contentParams;
    } else {
      throw new TrackerException(107, 'contentParams is not a valid object');
    }
  }

  getContentParams() {
    return this.contentParams;
  }

  setCommonContentParams(commonContentParams) {
    if (commonContentParams instanceof ContentCommonParams) {
      this.commonContentParams = commonContentParams;
    } else {
      throw new TrackerException(107, 'commonContentParams is not a valid object');
    }
  }

  getCommonContentParams() {
    return this.commonContentParams;
  }

  setExtraParams(extraParams) {
    this.extra = extraParams;
  }

  getUrlTracking(evtType, impressionType = null) {
    const eventType = evtType;
    if (!this.commonParams) {
      throw new TrackerException(104, 'commonParams for Tracking are empty');
    }
    if (!this.commonContentParams && this.typeContent === TYPECONTENT.CONTENT) {
      throw new TrackerException(104, 'commonContentParams for Tracking are empty');
    }

    if (!this.adParams && eventType !== EVENT_STATUS.REQUEST_DEMAND) {
      throw new TrackerException(105, 'adParams for Tracking are empty');
    }

    if (!this.adParams && eventType === EVENT_STATUS.REQUEST_DEMAND) {
      this.adParams = new AdParams({});
    }

    if (
      !impressionType &&
      (eventType === EVENT_STATUS.IMPRESSION || eventType === EVENT_STATUS.CONTENT_VIEW)
    ) {
      throw new TrackerException(108, 'Event Tracking IMPRESSION has to contain impressionType');
    }

    // eventType = this.checkDeliveryType(eventType);
    if (
      impressionType === EVENT_STATUS.IMPRESSION &&
      !checkImpression(impressionType, this.eventReached)
    ) {
      return null;
    }
    if (eventType === EVENT_STATUS.IMPRESSION || eventType === EVENT_STATUS.CONTENT_VIEW) {
      this.commonParams.setImpressionType(impressionType);
    }

    if (this.commonParams.build().s_prc_fx === 1) {
      // chequear parámetro prc_net_rs_g de ad
      // eslint-disable-next-line eqeqeq
      this.adParams.setPriceNetworkResponse(this.commonParams.build().prc_net_rq);
    }
    //
    // this.commonParams.setPriceFix(null); // quitamos el parametro para no enviarlo en el tracking

    this.commonParams.setEventStatus(eventType);
    this.commonParams.setImpressionType(impressionType);
    let paramsToSend = Object.assign(this.commonParams.build(), this.adParams.build());
    if (this.commonContentParams) {
      this.commonContentParams.setTimeStamp(TAPPX_GLOBAL_PARAMS.DATES.SERVICE_TIMESTAMP);
      paramsToSend = Object.assign(paramsToSend, this.commonContentParams.build());
    }

    let newParamsOrder = changeOrderAttributes(paramsToSend);

    delete newParamsOrder.s_prc_fx;
    const isPriceSend =
      eventType === EVENT_STATUS.DELIVERY ||
      eventType === EVENT_STATUS.IMPRESSION ||
      eventType === EVENT_STATUS.DELIVERY_WINNER;
    if (!isPriceSend) {
      delete newParamsOrder.prc_net_rs_g;
    }
    newParamsOrder = removeEmptyAttrFromObj(newParamsOrder);
    newParamsOrder.ts_local = new Date().getTime();

    if (this.extra) {
      const extraParamsString = JSON.stringify(this.extra.build());
      if (extraParamsString !== '{}') {
        newParamsOrder.ext_cli = extraParamsString;
      }
    }

    const objectConvertedInString = convertParamsToString(newParamsOrder);

    let endPoint = ENDPOINTS[eventType];
    if (eventType === EVENT_STATUS.IMPRESSION && this.typeContent === TYPECONTENT.CONTENT) {
      endPoint = ENDPOINTS[EVENT_STATUS.CONTENT_VIEW];
    }

    if (!endPoint) {
      throw new TrackerException(106, 'we don´t have endPoint to send tracking');
    }

    if (!process.env.DOMAIN_ENPOINT) {
      throw new TrackerException(
        109,
        'we don´t have endPoint domain to send tracking. Check your .env file',
      );
    }

    return `${process.env.DOMAIN_ENPOINT}${endPoint}?${objectConvertedInString}`;
  }

  send(eventType, impressionType) {
    const urlTrackings = this.getUrlTracking(eventType, impressionType);
    if (urlTrackings) {
      addTrackerToDOM(urlTrackings);
    } else {
      logError(`no hay endpoint para eventType ${eventType}`);
    }
  }

  getFrequency(response, reqDuration) {
    let status = '';
    let message = '';
    let hash = '';
    try {
      if (response.code !== undefined) {
        status = response.details.split('_').shift();
        hash = '';
        this.msg = response.details;
      } else {
        hash = response?.extra_data?.srv_hsh ?? '';
        if (response?.bid.length === 0) {
          status = response.error.code;
          message = response.error.message;
        } else {
          const noFill = response.bid[0].content[0].content_type === 'no_fill';
          status = noFill ? '204' : '200';
          message = noFill ? 'NO_FILL' : 'FILL';
        }
        this.msg = `${status}-${message}`;
      }
      this.hash = hash;
      return this.getClientTrackingFrequency(status, reqDuration);
    } catch (error) {
      logError(error);
      return null;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  sendToCLient(url, frequency) {
    const rand = Math.random() * 100;
    logDebugging(
      `RAND-----> ${rand};FREQUENCY-----> ${frequency}; ENV-----> ${process.env.NODE_ENV}`,
    );
    if (frequency > rand || process.env.NODE_ENV === 'development') {
      addTrackerToDOM(url);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  getClientTrackingFrequency(statusRecived, reqDuration) {
    let freq = '';
    let noCode = true;
    STATUS_FRQ.forEach(({ statusCode, timeRange, perc }) => {
      if (statusCode.includes(statusRecived)) {
        noCode = false;
        if (timeRange === '') {
          freq = perc.inTime;
          return;
        }
        const times = timeRange.split('_');
        freq = times[0] < reqDuration && times[1] > reqDuration ? perc.inTime : perc.outTime;
      }
    });
    freq = noCode ? 100 : freq;
    return freq;
  }

  checkDeliveryType(eventType) {
    const deliveryData = getDeliveryWinner(eventType, this.typeContent);
    this.adParams.setDeliveryWinner(deliveryData.deliveryWinner);
    return deliveryData.eventType;
  }

  checkDeliveryPos(eventType) {
    if (
      eventType === EVENT_STATUS.DELIVERY_WINNER ||
      (eventType === EVENT_STATUS.DELIVERY && this.params.build().dl_win === '1')
    ) {
      counterAd.increment();
    }
    if (
      eventType === EVENT_STATUS.DELIVERY_WINNER ||
      eventType === EVENT_STATUS.IMPRESSION ||
      (eventType === EVENT_STATUS.DELIVERY && this.params.build().dl_win === '1')
    ) {
      this.params.setDeliveryPos(counterAd.value());
      return;
    }
    this.params.setDeliveryPos(null);
  }

  checkAdParams(eventType) {
    if (this.typeContent === TYPECONTENT.AD) {
      // this.params.setTrackingId(this.tracking_id);
      this.checkDeliveryPos(eventType);

      this.params.setDeliveryVideoDisplay(
        eventType === EVENT_STATUS.IMPRESSION ? 'DISPLAYONVIDEO' : null,
      );

      this.params.setRequestType(this.typeContent);

      if (eventType === EVENT_STATUS.DELIVERY && TAPPX_GLOBAL_PARAMS.DATES.USER_TIMESTAMP) {
        this.params.setDeliveryTime(
          Math.floor(new Date().getTime()) - TAPPX_GLOBAL_PARAMS.DATES.USER_TIMESTAMP,
        );
      }
      if (eventType === EVENT_STATUS.REQUEST_DEMAND) {
        // RM 12446 https://redmine.tappx.com/issues/12446
        TAPPX_GLOBAL_PARAMS.DATES.tsDif =
          new Date().getTime() - TAPPX_GLOBAL_PARAMS.DATES.USER_TIMESTAMP;
        this.rq_ts_demand =
          TAPPX_GLOBAL_PARAMS.DATES.SERVICE_TIMESTAMP + TAPPX_GLOBAL_PARAMS.DATES.tsDif;

        this.params.setRequestTimeStamp(this.rq_ts_demand);
      }
      if (eventType === EVENT_STATUS.REQUEST_PUBLISHER || eventType === EVENT_STATUS.IMPRESSION) {
        // RM 12446 https://redmine.tappx.com/issues/12446
        const tsDif = new Date().getTime() - TAPPX_GLOBAL_PARAMS.DATES.USER_TIMESTAMP;
        TAPPX_GLOBAL_PARAMS.DATES.ts_rq_publisher =
          TAPPX_GLOBAL_PARAMS.DATES.SERVICE_TIMESTAMP + tsDif;
        TAPPX_GLOBAL_PARAMS.DATES.ts_dif = tsDif;
        this.params.setRequestTimeStamp(TAPPX_GLOBAL_PARAMS.DATES.ts_rq_publisher);
      }

      if (eventType !== EVENT_STATUS.REQUEST_PUBLISHER) {
        this.params.setNumAds(null);
      }

      // ESTO NO CREO QUE HAGA FALTA PARA LAS LLAMADAS CON EL SSP
      // this.setNetworkIdForDisplay();

      this.params.setElapsedTimeGlobal(
        new Date().getTime() - TAPPX_GLOBAL_PARAMS.DATES.USER_TIMESTAMP,
      );
    }
  }
}
